<div class="approve-final-cost" data-testid="approve-final-cost-content">
  <button
    type="button"
    class="approve-final-cost__back"
    data-testid="approve-final-cost-back"
    (click)="onBack()"
  >
    <mat-icon class="approve-final-cost__back-icon" aria-hidden="true">
      chevron_left
    </mat-icon>
    <span>Back to final cost preview</span>
  </button>

  <p class="approve-final-cost__help">
    You are responsible for ensuring your PO covers the full updated total cost.
    If your current PO is insufficient, please request a complementary PO to
    cover the difference.
  </p>

  <app-quote-cost-card
    [deliveryType]="deliveryType()"
    [deliveryDate]="deliveryDate()"
    [quoteId]="quoteId()"
    [currency]="currency()"
    [costBreakdown]="[]"
    [totalCost]="totalCost()"
    [summaryOnly]="true"
  />

  <div class="approve-final-cost__field">
    <label class="approve-final-cost__label" for="approve-final-cost-po">
      Purchase Order ID
    </label>
    <input
      id="approve-final-cost-po"
      class="approve-final-cost__input"
      data-testid="approve-final-cost-po"
      type="text"
      inputmode="numeric"
      autocomplete="off"
      maxlength="20"
      required
      [value]="purchaseOrderId()"
      (input)="onPurchaseOrderInput($event)"
    />
  </div>
</div>
